import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { auth, sendPasswordResetEmail } from "../utils/firebase";
import { Link } from "react-router-dom";
import {
  doc,
  getDoc
} from 'firebase/firestore';

import {
  db
} from "../utils/firebase";

import { TokenContext } from "./tokenContext"; // import TokenContext
import { logout } from "../utils/firebase";
import { createPortal } from "react-dom";
import GlobalNavDrawer from "./GlobalNavDrawer";
import { useAuth } from './AuthContext';
import "./JobBankPasswordReset.css";

function JobBankPasswordReset() {
    const { balance, setBalance } = useContext(TokenContext);
      const { currentUser } = useAuth();
      useEffect(() => {
            let isMounted = true;
        
            const fetchTokens = async () => {
              if (!currentUser?.uid) return;
        
              const userRef = doc(db, "users", currentUser.uid);
        
              try {
                const userDoc = await getDoc(userRef);
        
                if (userDoc.exists() && isMounted) {
                  setBalance(userDoc.data().tokens ?? 0);
                }
              } catch (error) {
                console.error("Error fetching token count:", error);
              }
            };
        
            fetchTokens();
        
            return () => {
              isMounted = false;
            };
          }, [currentUser, setBalance]);
  const [email, setEmail] =
    useState("");

  const [error, setError] =
    useState("");

  const [message, setMessage] =
    useState("");

  const navigate =
    useNavigate();

  const navigateTo = (path) => {
    navigate(path);
  };

  const handlePasswordReset =
    async (event) => {

      event.preventDefault();

      setError("");

      try {

        await sendPasswordResetEmail(
          auth,
          email
        );

        setMessage(
          "Check your email (including spam or junk folders) for your password reset instructions."
        );

      } catch (error) {

        console.error(
          "Error sending password reset email:",
          error
        );

        setError(
          "Failed to send password reset email. Please try again."
        );
      }
    };

  return (

    <div className="JBPR-container">

      <div className="JBPR-card">

        <h1 className="JBPR-title">
          Community Job Bank
        </h1>

        <p className="JBPR-subtitle">
          Powered by The iSpeakWell Project
        </p>

        <p className="JBPR-description">
          Connecting Local Talent with Local Opportunity.
        </p>

        <h2 className="JBPR-heading">
          Reset Your Password
        </h2>

        <form
          className="JBPR-form"
          onSubmit={handlePasswordReset}
        >

          <input
            className="JBPR-input"
            type="email"
            placeholder="Enter the email associated with your account"
            value={email}
            onChange={(e) =>
              setEmail(
                e.target.value
              )
            }
          />

          <button
            className="JBPR-button"
            type="submit"
          >
            Send Reset Link
          </button>

        </form>

        <h3 className="JBPR-link-text">

          Remembered your password?

          {" "}

          <Link
            className="JBPR-link"
            to="/jobbank/login"
          >
            Sign In
          </Link>

        </h3>

        {
          message && (
            <div className="JBPR-success">
              {message}
            </div>
          )
        }

        {
          error && (
            <div className="JBPR-error">
              {error}
            </div>
          )
        }

        <div className="JBPR-links">

          <button
            className="JBPR-footer-link"
            onClick={() =>
              navigateTo("/jobbank/about")
            }
          >
            About Us
          </button>

          <button
            className="JBPR-footer-link"
            onClick={() =>
              navigateTo("/jobbank/contact")
            }
          >
            Contact
          </button>

          <button
            className="JBPR-footer-link"
            onClick={() =>
              navigateTo("/jobbank/help")
            }
          >
            Help
          </button>

          <button
            className="JBPR-footer-link"
            onClick={() =>
              navigateTo("/jobbank/login")
            }
          >
            Sign In
          </button>

        </div>

      </div>
        {createPortal(
                <GlobalNavDrawer
                  hideCurrent
                  links={[
                    { to: "/purchase", label: `Tokens: ${balance}`},
                    { to: "/jobbank", label: "Job Bank Home"},
                    { to: "/voicebot", label: "iSpeakWell" },
                    { to: "/resumerevisor", label: "Resumes" },
                    { to: "/conversationpractice", label: "Convos" },
                    { to: "/interview-practice", label: "Interviews" },
                    { to: "/termsofservice", label: "Terms" },
                    { to: "/privacypolicy", label: "Privacy" },
                    { to: "/admin", label: "Admin" },
                    { to: "/login", label: "Logout", onClick: async () => { await logout(); } },
                  ]}
                />,
                  document.body
              )}
    </div>

  );
}

export default JobBankPasswordReset;